// extracted by css-extract-rspack-plugin
export default {"start-button":"WVmOEY","startButton":"WVmOEY","hidden":"ZvdSEs"};